<template>
	<div>
		<v-card>
			<v-card-title class="titleCard">
				<h5 class="title text-uppercase">Detalles</h5>
			</v-card-title>
			<v-divider></v-divider>
			<v-card-text>
				<v-flex xs12>
					<h5 class="text-xs-center mb-1 text-uppercase">Compras</h5>
				</v-flex>
				<app-table
					:rows="rows"
					:columns="columns"
					:input-search="false"
					:t-foot="false"
				>
					<template slot="rows" slot-scope="props">
						<td v-show="showRow(columns, 1)">{{ props.row.cod }}</td>
						<td v-show="showRow(columns, 2)">{{ props.row.transaction }}</td>
						<td v-show="showRow(columns, 3)">{{ props.row.valRecords }}</td>
						<td v-show="showRow(columns, 4)">
							{{ props.row.amountBaseZero | round }}
						</td>
						<td v-show="showRow(columns, 5)">
							{{ props.row.amountDifZero | round }}
						</td>
						<td v-show="showRow(columns, 6)">
							{{ props.row.amountObjExpIva | round }}
						</td>
						<td v-show="showRow(columns, 7)">
							{{ props.row.amountIva | round }}
						</td>
					</template>
				</app-table>
				<v-flex xs12 mt-2>
					<h4 class="text-xs-center mb-1 text-uppercase">
						Resumen de Retenciones - Agentes de Retención
					</h4>
				</v-flex>
				<v-flex xs12>
					<h5 class="text-xs-center mb-1 text-uppercase">
						Retención en la fuente de impuesto a la Renta
					</h5>
				</v-flex>
				<app-table
					:rows="rentRetentions"
					:columns="columnsRent"
					:input-search="false"
					:t-foot="false"
				>
					<template slot="rows" slot-scope="props">
						<td v-show="showRow(columnsRent, 1)">{{ props.row.code }}</td>
						<td v-show="showRow(columnsRent, 2)">{{ props.row.concept }}</td>
						<td v-show="showRow(columnsRent, 3)">{{ props.row.count }}</td>
						<td v-show="showRow(columnsRent, 4)">
							{{ props.row.baseSubtotal | round }}
						</td>
						<td v-show="showRow(columnsRent, 5)">
							{{ props.row.retention | round }}
						</td>
					</template>
				</app-table>
				<v-flex xs12>
					<h5 class="text-xs-center mb-1 text-uppercase">
						Retención en la fuente de iva
					</h5>
				</v-flex>
				<app-table
					:rows="ivaRetentions"
					:columns="columnsIva"
					:input-search="false"
					:t-foot="false"
				>
					<template slot="rows" slot-scope="props">
						<td v-show="showRow(columnsIva, 1)">{{ props.row.operation }}</td>
						<td v-show="showRow(columnsIva, 2)" style="width: 79%;">
							{{ props.row.concept }}
						</td>
						<td v-show="showRow(columnsIva, 3)">
							{{ props.row.retention | round }}
						</td>
					</template>
				</app-table>
				<v-divider></v-divider>
				<v-layout justify-end mt-3>
					<v-flex xs1 ml-3>
						<v-btn
							:disabled="rows.length === 0"
							color="#f42b17"
							@click="$emit('close')"
						>
							<span class="btn-close">Cerrar</span>
						</v-btn>
					</v-flex>
				</v-layout>
			</v-card-text>
		</v-card>
	</div>
</template>

<script>
import appTable from '@/components/shared/table/app-table';

function created() {
	const purchaseGroup = {};
	console.log('this.details::: ', this.details);
	this.details.forEach((purchase) => {
		const typeDocumentId = purchase.purchase.typeDocument.id;

		// Si typeDocumentId es un número válido, agrégalo a purchaseGroup
		if (!isNaN(typeDocumentId)) {
			if (!purchaseGroup[typeDocumentId]) {
				purchaseGroup[typeDocumentId] = [];
			}
			purchaseGroup[typeDocumentId].push(purchase);
		}
	});
	console.log('purchaseGroup::: ', purchaseGroup);
	// Filtra y elimina los valores nulos del objeto purchaseGroup
	const filteredPurchaseGroup = Object.values(purchaseGroup).filter(Boolean);
	console.log('filteredPurchaseGroup::: ', filteredPurchaseGroup);
	const newArray = [];

	this.rows = filteredPurchaseGroup;
	console.log('this.rwwows::: ', this.rows);
	this.rows.forEach((newPurchase) => {
		const cod = newPurchase[0].purchase.typeDocument.codeTaxes;
		const transaction = newPurchase[0].purchase.typeDocument.name;
		const valRecords = newPurchase.length;
		let sumBaseZero = 0;
		let sumBaseDifZero = 0;
		let ObjExpIva = 0;
		let sumIva = 0;
		newPurchase.forEach((entry) => {
			sumIva += entry.purchase.taxes || 0;
			entry.purchase.details.forEach((detail) => {
				const tax = detail.tax || 0;
				if (tax === 0) {
					sumBaseZero += detail.subtotalWithoutTax || 0;
				} else {
					sumBaseDifZero += detail.subtotalWithoutTax || 0;
				}
				ObjExpIva = 0;
			});
		});
		const amountBaseZero = sumBaseZero;
		const amountDifZero = sumBaseDifZero;
		const amountObjExpIva = ObjExpIva;
		const amountIva = sumIva;
		const newObj = {
			cod,
			transaction,
			valRecords,
			amountBaseZero,
			amountDifZero,
			amountObjExpIva,
			amountIva,
		};
		newArray.push(newObj);
	});
	this.rows = newArray;
	this.loadIvaRentRetentions();
}

function loadIvaRentRetentions() {
	const retentions = this.details.reduce((acc, item) => {
		const acum = [...acc];
		item.details.forEach((det) => {
			const foundIndex = acum.findIndex(f => f.code === det.code);
			if (foundIndex !== -1) {
				acum[foundIndex].count += 1;
				acum[foundIndex].baseSubtotal +=
					det.name === 'RENTA' ? det.baseSubtotal : 0;
				acum[foundIndex].baseIva += det.name === 'IVA' ? det.baseIva : 0;
				acum[foundIndex].retention += det.totalTax;
			} else {
				acum.push({
					operation: 'COMPRA',
					code: det.code,
					name: det.name,
					concept: det.nameCodePercentage,
					count: 1,
					baseSubtotal: det.name === 'RENTA' ? det.baseSubtotal : 0,
					baseIva: det.name === 'IVA' ? det.baseIva : 0,
					retention: det.totalTax,
				});
			}
		});
		return acum;
	}, []);

	this.rentRetentions = retentions
		.filter(f => f.name !== 'IVA')
		.sort((a, b) => a.code.localeCompare(b.code));
	this.ivaRetentions = retentions
		.filter(f => f.name !== 'RENTA')
		.sort((a, b) => a.code.localeCompare(b.code));
}

function data() {
	return {
		properties: [
			'id',
			'code',
			'transaction',
			'registers',
			'zeroFee',
			'notZeroFee',
			'baseIva',
			'valueIva',
		],
		columns: [
			{ id: 1, name: 'Cod', value: 'code', checked: true, visible: true },
			{
				id: 2,
				name: 'Transacción',
				value: 'code',
				checked: true,
				visible: true,
			},
			{
				id: 3,
				name: 'No. Registros',
				value: 'registers',
				checked: true,
				visible: true,
			},
			{
				id: 4,
				name: 'BI tarifa 0%',
				value: 'feezero',
				checked: true,
				visible: true,
			},
			{
				id: 5,
				name: 'BI tarifa dieferente 0%',
				value: 'notfeezero',
				checked: true,
				visible: true,
			},
			{
				id: 6,
				name: 'BI No Objeto IVA',
				value: 'baseSub',
				checked: true,
				visible: true,
			},
			{
				id: 7,
				name: 'Valor IVA',
				value: 'valueIva',
				checked: true,
				visible: true,
			},
		],
		columnsRent: [
			{ id: 1, name: 'Cod', value: 'code', checked: true, visible: true },
			{
				id: 2,
				name: 'Concepto de Retención',
				value: 'concept',
				checked: true,
				visible: true,
			},
			{
				id: 3,
				name: 'No. Registros',
				value: 'registers',
				checked: true,
				visible: true,
			},
			{
				id: 4,
				name: 'Base Imponible',
				value: 'base',
				checked: true,
				visible: true,
			},
			{
				id: 5,
				name: 'Valor Retenido',
				value: 'value',
				checked: true,
				visible: true,
			},
		],
		columnsIva: [
			{
				id: 1,
				name: 'Operación',
				value: 'operation',
				checked: true,
				visible: true,
			},
			{
				id: 2,
				name: 'Concepto de Retención',
				value: 'concept',
				checked: true,
				visible: true,
			},
			{
				id: 3,
				name: 'Valor Retenido',
				value: 'value',
				checked: true,
				visible: true,
			},
		],
		rows: [],
		rentRetentions: [],
		ivaRetentions: [],
	};
}

export default {
	name: 'ats-purchases-details',
	data,
	created,
	components: {
		appTable,
	},
	methods: {
		loadIvaRentRetentions,
	},
	props: {
		details: {
			type: Array,
			default: () => [],
		},
	},
};
</script>

<style lang="scss" scoped>
.header-cell,
.cell {
	border: 1px solid #ccc;
	padding: 10px;
	text-align: center;
}
.header-cell {
	font-weight: bold;
	background-color: #f0f0f0;
}
.btn-close {
	color: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/components/ats-purchases/ats-purchases-details.vue